import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

class FirebaseService {
    init() {
        if (firebase.apps.length < 1) return;

        this.db = firebase.firestore();
        this.storage = firebase.storage().ref();
        this.auth = firebase.auth();
        this.functions = firebase.functions();
    }

    /* #region Groups */
    createGroup = (payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("groups")
                .add(payload)
                .then((response) => {
                    // resolve(response);
                    resolve({ id: response.id });
                });
        });
    };

    updateGroup = (groupId, payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .doc(groupId)
                .update(payload)
                .then((snapshot) => {
                    resolve(snapshot);
                });
        });
    };

    deleteGroup = (groupId) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("groups")
                .doc(groupId)
                .delete()
                .then(() => {
                    resolve();
                });
        });
    };

    deleteGroupUsers = (users) => {
        const groupsFunctions = [];

        users?.forEach(async (usr) => {
            const groups = await this.db.collection("junction_group_student")
                .where("studentId", "==", usr.id)
                .get();

            groups.forEach((doc) => {
                this.db.collection("junction_group_student").doc(doc.id).delete();
            });

            groupsFunctions.push(this.deleteUser(usr.id));
        });

        return Promise.all(groupsFunctions)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject({
                    error: error,
                });
            });
    };

    updateGroupsCycle = (cycleId, cycleName, removeGroupsCycle, addGroupsCycle) => {
        const groupsFunctions = [];

        removeGroupsCycle?.forEach((group) => {
            const payload = { cycle_id: "", cycle_name: "" };
            groupsFunctions.push(this.updateGroup(group.id, payload));
        });

        addGroupsCycle?.forEach((group) => {
            const payload = { cycle_id: cycleId, cycle_name: cycleName };
            groupsFunctions.push(this.updateGroup(group.id, payload));
        });

        return Promise.all(groupsFunctions)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject({
                    error: error,
                });
            });
    };

    getGroups = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getGroupById = (groupId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .doc(groupId)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };

    getGroupByName = (name) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .where("name", "==", name)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs.length > 0 ? docs[0] : undefined);
                });
        });
    };

    getGroupsByCycleId = (cycleId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .where("cycle_id", "==", cycleId)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getGroupsWithoutCycle = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`groups`)
                .where("cycle_id", "==", "")
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };
    /* #endregion */

    /* #region Cycle */
    createCycle = (payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("cycles")
                .add(payload)
                .then((response) => {
                    // resolve(response);
                    resolve({ id: response.id });
                });
        });
    };

    updateCycle = (cycleId, payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("cycles")
                .doc(cycleId)
                .update(payload)
                .then((response) => {
                    resolve(response);
                });
        });
    };

    getCycles = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`cycles`)
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getCycleById = (cycleId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`cycles`)
                .doc(cycleId)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };
    /* #endregion */

    /* #region Activities */
    createActivity = (payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("activities")
                .add(payload)
                .then((response) => {
                    // resolve(response);
                    resolve({ id: response.id });
                });
        });
    };

    updateActivity = (activityId, payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("activities")
                .doc(activityId)
                .update(payload)
                .then((response) => {
                    resolve(response);
                });
        });
    };

    // Una de las pruebas para actualizar con multiples clicks, no funciona
    // updateActivityToUser = (activityId) => {
    //     return new Promise((resolve, reject) => {
    //         const increment = firebase.firestore.FieldValue.increment(1);  
    //         this.db
    //             .collection("activities")
    //             .doc(activityId)
    //             .update({inscribed: increment})
    //             // .update(payload)
    //             .then((response) => {
    //                 resolve(response);
    //             });
    //     });
    // };

    updateActivityToUser = (activityId) => {
        return new Promise(async (resolve, reject) => {
            const FieldValue = firebase.firestore.FieldValue; 
            const activityRef = this.db.collection('activities').doc(activityId);

            // Atomically increment the population of the city by 50.
            // eslint-disable-next-line no-unused-vars
            const res = await activityRef
            .update({inscribed: FieldValue.increment(1)})
            .then((response) => {resolve(response);
            });
    });
};     

    getActivityById = (activityId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`activities`)
                .doc(activityId)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };

    getUserActivity = (activityId, studentId) => {
        if (!firebase.apps.length) return false;

        // const junctionRef = firebaseService.db?.doc(`junction_student_activity/${studentId}_${activityId}`);
        return new Promise((resolve, reject) => {
            this.db
                .doc(`junction_student_activity/${studentId}_${activityId}`)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };

    getActivities = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`activities`)
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getTeacherActivities = (teacher) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`activities`)
                .where("deleted", "==", false)
                .where("contact", "==", teacher)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    /* #endregion */

    /* #region Users */
    createUser = (payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("users")
                .doc(payload.email)
                .set(payload)
                .then((response) => {
                    // resolve(response);
                    resolve();
                });
        });
    };

    updateUser = (userId, payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("users")
                .doc(userId)
                .update(payload)
                .then((response) => {
                    resolve(response);
                });
        });
    };

    deleteUser = (userId) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("users")
                .doc(userId)
                .delete()
                .then(() => {
                    resolve();
                });
        });
    };

    disableMultiUsers = (usersId) => {
        const usersFunctions = [];

        usersId?.forEach((userId) => {
            usersFunctions.push(this.updateUser(userId, { deleted: true }));
        });

        return Promise.all(usersFunctions)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject({
                    error: error,
                });
            });
    };

    // setUser = (user) => {
    //     return new Promise((resolve, reject) => {
    //         return this.db
    //             .doc(`users/${user.email}`)
    //             .set(user)
    //             .then(() => {
    //                 resolve({ id: user.email });
    //             });
    //     });
    // };

    getLoggedUser = () => {
        if (!firebase.apps.length) return undefined;

        return new Promise((resolve, reject) => {
            const user = firebase.auth().currentUser;
            resolve(user);
        });
    };

    getUsers = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`users`)
                .where('deleted', '==', false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        })
    };

    getTeachers = async () => {
        if (!firebase.apps.length) return false;

        const teachersGroup = await this.getGroupByName("users_teacher");
        if (!teachersGroup) return false;

        const junctionsGroupStudent = await this.db?.collection('junction_group_student')
            .where('groupId', '==', teachersGroup.id)
            .get();
        if (!junctionsGroupStudent) return false;

        return Promise.all(junctionsGroupStudent?.docs.map(stgrp => this.db?.doc(`users/${stgrp.data().studentId}`).get().then(snap => ({ id: snap.id, ...snap.data() }))));
    };

    setUser = (user) => {
        return new Promise(async (resolve, reject) => {
            const ref = await this.db.doc(`users/${user.email}`);
            const userDB = await ref.get();

            if (userDB.exists)
                return resolve();

            return ref
                .set(user)
                .then(() => {
                    resolve({ id: user.email });
                });
        });
    };

    getUsersTeacher = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`users`)
                .where('admin', '==', true)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getUserById = (userId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`users`)
                .doc(userId)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };

    getUsersWithoutGroup = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`users`)
                .where("group_id", "==", "")
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };
    /* #endregion */

    /* #region Locations */
    createLocation = (payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("locations")
                .add(payload)
                .then((response) => {
                    // resolve(response);
                    resolve({ id: response.id });
                });
        });
    };

    updateLocation = (locationId, payload) => {
        return new Promise((resolve, reject) => {
            this.db
                .collection("locations")
                .doc(locationId)
                .update(payload)
                .then((response) => {
                    resolve(response);
                });
        });
    };

    getLocations = () => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`locations`)
                .where("deleted", "==", false)
                .get()
                .then((snapshot) => {
                    const docs = [];
                    snapshot.forEach((doc) => {
                        docs.push({ id: doc.id, ...doc.data() });
                    });

                    resolve(docs);
                });
        });
    };

    getLocationById = (locationId) => {
        if (!firebase.apps.length) return false;

        return new Promise((resolve, reject) => {
            this.db
                .collection(`locations`)
                .doc(locationId)
                .get()
                .then((snapshot) => {
                    resolve({ id: snapshot.id, ...snapshot.data() });
                });
        });
    };
    /* #endregion */

    /* #region File */
    getFile = (fileRef) => {
        return new Promise((resolve, reject) => {
            this.storage
                .child(fileRef)
                .getDownloadURL()
                .then((url) => {
                    resolve(url);
                })
                .catch(() => {
                    resolve()
                })
        });
    }

    uploadFile = (file) => {
        return new Promise((resolve, reject) => {
            this.storage
                .child(file.fileName)
                .put(file.file)
                .then(function (snapshot) {
                    snapshot.ref
                        .getDownloadURL()
                        .then((url) => {
                            resolve({
                                uploadedFile: snapshot,
                                url: url,
                                field: file.field,
                                fileName: file.fileName
                            });
                        })
                });
        });
    }

    uploadFiles = (files) => {
        const filesFunctions = [];
        files.forEach(file => {
            filesFunctions.push(this.uploadFile(file))
        });

        return Promise.all(filesFunctions).then((response) => {
            const files = [];

            response.forEach(element => {
                files.push({ field: element.field, fileName: element.fileName, url: element.url })
            });

            return Promise.resolve(files)
        }).catch(error => {
            return Promise.reject({
                error: error
            });
        });
    }
    /* #endregion */
}

const instance = new FirebaseService();

export default instance;